import dayjs from "dayjs";

// Constants
import { exampleImageRecord } from "constants/tournament";

// Types
import {
  ImageRecord,
  TournamentDataType,
  TournamentStatus,
} from "types/Tournament";

export const setTournamentStatus = (tournament: TournamentDataType) => {
  const now = dayjs();
  const start = dayjs(tournament.startDate);
  const end = dayjs(tournament.endDate);
  if (now < start) {
    return TournamentStatus.ANNOUNCE;
  }
  if (end < now) {
    return TournamentStatus.FINISHED;
  }
  return TournamentStatus.ACTIVE;
};

export const getImageSet = (
  images: ImageRecord[],
  isTablet: boolean,
): string => {
  if (images.length) {
    const imageSet = images[0];
    return isTablet ? imageSet.mobile : imageSet.main;
  }
  return isTablet ? exampleImageRecord.mobile : exampleImageRecord.main;
};
